import { render, staticRenderFns } from "./AddGroupMemberModal.vue?vue&type=template&id=0225c836&scoped=true"
import script from "./AddGroupMemberModal.vue?vue&type=script&lang=js"
export * from "./AddGroupMemberModal.vue?vue&type=script&lang=js"
import style0 from "./AddGroupMemberModal.vue?vue&type=style&index=0&id=0225c836&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0225c836",
  null
  
)

export default component.exports